<template>
  <div class="content">
    <div v-for="info of recipeInfo" :key="info.recipeId">
      <div class="title">银川零氪互联网医院处方笺</div>
      <div class="type">{{ info.recipeType }}</div>
      <div class="twoColumns">
        <div class="ordercode">处方编号：{{ info.order_code }}</div>
        <div class="right">{{ info.createTime }}</div>
      </div>
      <div class="threeColumns">
        <div class="name">姓名：{{ info.name }}</div>
        <div class="sex">性别：{{ info.sex }}</div>
        <div class="age">年龄：{{ info.age ? info.age : '' }}</div>
      </div>
      <div class="pb10 mt10">临床诊断：{{info.diagnoseStr}}</div>

      <div class="rpContent">
        <div class="rp">Rp:</div>
         <div v-for="(item,index) in info.drugList" :key="index" class="drugItemRaw">
              <span>·{{ item.drugName }} （{{ item.usage }}）</span><span class="mt10">{{ item.actualSpecification }}</span>
            
            </div>
                 <div class="mt10">用法用量：{{info.dosage}}</div> 
      </div>

      <div class="threeColumns">
        <div>审核：{{info.auditorName}}</div>
        <div>复核：{{info.checkName}}</div>
        <div>调配：{{info.operateName}}</div>
      </div>
      <div class="twoColumns">
        <div>医师：{{info.creatorName}}</div>
        <div class="right">费别：{{info.type}}</div>
      </div>
      <div class="mt10">
        药师提示：1.鉴于药物都有一定的副作用，请您在服药前仔细阅读说明书，了解禁忌及慎用情况；2.处方1日内有效。
      </div>
    </div>
  </div>
</template>
<script>
import axios from '../services/recipe';
// import {Toast as VanToast, Dialog} from 'vant';

export default {
  data() {
    return {
      recipeInfo: []
    };
  },

  mounted() {
    this.getPrescriptionInfo();
  },
  methods: {
    // 获取处方笺信息
    getPrescriptionInfo() {
      const params = {
        recipeId: this.$route.params.id
      };
      axios.getRecipeInfo(params).then(res => {
        if (res.data.data.status && res.data.data.status === 'success') {
          this.recipeInfo =
            res.data.data.data instanceof Array ? res.data.data.data : [res.data.data.data];
          this.recipeInfo.forEach(info => {
            if (info.diagnose) {
              const diagnoseStr = info.diagnose.join('，');
              info.diagnoseStr = diagnoseStr;
            }
            if (info.gender == 1) {
              info.sex = '男';
            } else if (info.gender == 2) {
              info.sex = '女';
            } else {
              info.sex = '';
            }
          });
          this.timeFn(this.recipeInfo[0].validTerm);
          this.showTemplate = true;
        }
      });
    },
    // 时间处理
    timeFn(date) {
      if (!date) {
        return;
      }
      let dateBegin = Date.parse(new Date(date.replace(/-/g, '/')));
      dateBegin = new Date(dateBegin + 24 * 60 * 60 * 1000);
      const years = dateBegin.getFullYear();
      const month = dateBegin.getMonth() + 1;
      const dates = dateBegin.getDate();
      this.expireTime = `${years}-${month}-${dates}`;
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  padding: 10px 10px;
  .title {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
  }
  .type {
    display: block;
    text-align: right;
    font-weight: bold;
  }
  .twoColumns {
    display: flex;
    border-bottom: 1px solid #000;
    margin-top: 10px;
    padding-bottom: 10px;
    div {
      width: 50%;
    }
    .right {
      text-align: right;
    }
  }
  .threeColumns {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #000;
    div {
      width: 33%;
    }
  }
  .rpContent {
    width: 100%;
    margin-top: 10px;
    padding-bottom: 10px;
    .rp {
      font-size: 18px;
      font-weight: bold;
    }
  }
}
.mt10 {
  margin-top: 10px;
}
.pb10 {
  padding-bottom: 10px;
  border-bottom: 1px solid #000;
}
</style>
